import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { Button, Grid, Alert, Tooltip } from "@mui/material";
// import Button from '@mui/material/Button';

import Spinner from "../Spinner/Spinner";

import { Props } from "./interface";
import { Actions, SaveButton } from "./styles";

const DialogActions = ({
  handleCancel,
  handleSave,
  handleDelete,
  canBeDeleted,
  disabledSaveButton = false,
  disabledCancelButton = false,
  customSaveName,
  customDeleteName,
  error,
  loading,
  children,
  useGoback,
  saveButtonOrder,
  saveButtonTooltip,
  customSaveStyle,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Actions>
      <Button
        onClick={(event) => {
          event?.preventDefault();
          handleCancel();
        }}
        variant="outlined"
        disabled={disabledCancelButton}
        style={{
          order: 0,
          color: theme.palette.actions.cancel,
          borderColor: theme.palette.actions.cancel,
        }}
      >
        {useGoback ? t("buttons.go_back") : t("buttons.cancel")}
        {/* {`${t("buttons.go_back")}`} */}
      </Button>

      {error && <Alert severity="error">{error}</Alert>}

      {loading && (
        <Spinner
          size="3x"
          color={theme.palette.primary.main}
        />
      )}

      {handleDelete && canBeDeleted && (
        <SaveButton
          onClick={handleDelete}
          variant="outlined"
          disabled={disabledSaveButton || loading}
          style={{
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
          }}
        >
          <>{customDeleteName ?? t("buttons.delete")}</>
        </SaveButton>
      )}

      {handleSave && (
        <SaveButton
          onClick={handleSave}
          variant="contained"
          disabled={disabledSaveButton || loading}
          style={{ ...customSaveStyle, order: saveButtonOrder ?? 1, pointerEvents: "auto" }}
          title={saveButtonTooltip ?? customSaveName ?? t("buttons.save")}
        >
          <>{customSaveName ?? t("buttons.save")}</>
        </SaveButton>
      )}

      {children}
    </Actions>
  );
};

export default DialogActions;
